import styled from '@emotion/styled';

export const MerchantStatus = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const H5 = styled.h5`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: grey;
  margin: 10px 0;
`;

export const MerchantStatusTable = styled.ul`
  width: 100%;
  padding-left: 0;
  margin-top: 20px;
  text-color: #6c7488;
  width: 500px;
  font-size: 14px;

  li {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #e5e5e5;

    .item-label {
      font-weight: 500;
      color: #6c7488;
    }
    .item-value {
      font-weight: bold;
      color: #000;
      text-align: right;
      max-width: 60%;
      word-break: break-word;
    }
    .error-list {
      margin: 0;
      padding-left: 20px;
      list-style: disc;
      li {
        border-bottom: none;
      }
    }
    .error {
      font-size: 12px;
    }
  }
`;

export const MerchantStatusActions = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-top: 20px;

  li {
    margin-bottom: 10px;
  }
`;
